// extracted by mini-css-extract-plugin
module.exports = {"coronaPhotoSlider":"np8ju","prime_case":"I9N4l","arrows":"U3OD7","left":"siJSC","etimes_arrow":"PQIAg","right":"wNklI","photostory_slider":"g8DoS"};